import jQueryBridget from 'jquery-bridget';
import Isotope from 'isotope-layout';
import 'Lightbox2';
import 'jquery-zoom';
import ImageCompare from 'image-compare-viewer';
import Flickity from 'flickity'
import 'flickity-imagesloaded';

const defaultMapStyle = require('../mapstyle-dark-grey.json');
const google = window.google

export default {
  init() {
    $('.community-navigation-btn').on('click', function() {
      $('.community-navigation-btn').toggleClass('menu-active');
      $('.community-navigation').toggleClass('show');
    });

    $('.community-navigation').on('click', '.nav-link', function() {
      //... Smooth scroll if needed?
      $('.community-navigation').removeClass('show');
      $('.community-navigation-btn').removeClass('menu-active');
    });

    $('.modal--floorplan-viewer').on('show.bs.modal', function(e) {
      let target = $(e.relatedTarget).data('group');
      $('.group-tabs a[href="'+target+'"]').tab('show');
    });

    $('.modal--floorplan-viewer a[data-toggle="tab"]').on('show.bs.tab', function (e) {
      let target = $(e.target).data('sync');
      $(target)
        .addClass('active show')
        .siblings('.tab-pane.active')
        .removeClass('active show');

      console.log('test');

      // Hack to fix issue where dropdown toggle was removing modal class
      if ($('.modal.show').length > 0) {
        $('body').addClass('modal-open');
      }
    });

    function modalStateUpdate() {
      // Hack to fix issue where dropdown toggle was removing modal class
      if ($('.modal.show').length > 0) {
        $('body').addClass('modal-open');
      }
    }

    $('.tab-content-group .dropdown').on('hide.bs.dropdown', function (e) {
      var activeText = $(e.target).find('.dropdown-item.active').html();
      $(e.relatedTarget).html(activeText);
      modalStateUpdate();
    });

    $('.tab-content-floorplans .nav-link').on('show.bs.tab', function () {
      modalStateUpdate();
    });

    // init Isotope
    // ==============================
    jQueryBridget('isotope', Isotope, $ );

    var $grid = $('.section--image-gallery .grid-gallery').isotope({
      // options
    });

    $grid.imagesLoaded().progress( function() {
      $grid.isotope('layout');
    });

    var $filterButtonGroup = $('.section--image-gallery .filter-button-group');

    if ( $filterButtonGroup ) {
      // filter items on button click
      $filterButtonGroup.on( 'click', '.filter-button', function() {
        var filterValue = $(this).attr('data-filter');

        $grid.isotope({ filter: filterValue });

        $(this).addClass('active').siblings('.filter-button').removeClass('active');

        //Make lightbox respect filters
        $('.grid-image-lightbox').attr('data-lightbox', 'inactive-filter');
        $($(this).data('filter') + ' .grid-image-lightbox').attr('data-lightbox', 'active-filter');
      });
    }

    // Flickity
    // ==============================
    Flickity.setJQuery($);
    jQueryBridget('flickity', Flickity, $);

    // Instagram Feed
    var $instagramFeed = $('.instagram-feed-images').flickity({
      wrapAround: true,
      cellAlign: 'left',
      pageDots: false,
      autoPlay: 8000,
      imagesLoaded: true,
      prevNextButtons: false,
    });

    // Previous
    $('.instagram-feed-buttons').on( 'click', '.btn--previous', function() {
      $instagramFeed.flickity('previous');
    });

    // next
    $('.instagram-feed-buttons').on( 'click', '.btn--next', function() {
      $instagramFeed.flickity('next');
    });

    // Floorplans
    $('.floorplan-groups').flickity({
      wrapAround: true,
      pageDots: false,
      groupCells: true,
      watchCSS: true,
    });

    // Image Comparison
    // ==============================
    const viewers = document.querySelectorAll('.image-compare-view');

    const viewerOptions = {
      fluidMode: true,
    }

    viewers.forEach((element) => {
      new ImageCompare(element, viewerOptions).mount();
    });

    //Zoom
    // ==============================
    // $('.fpv-image')
    //   .css('display', 'block').css('background-color', '#ffffff')
    //   .parent()
    //   .zoom({magnify:2});

    $('.btn-image-zoom').on('click', function() {
      var $imgContainer = $(this).next('.image-container');
      // var $image = $parent.find('.fpv-image');

      if ( $imgContainer.hasClass('zooming') ) {
        $imgContainer.removeClass('zooming').trigger('zoom.destroy');
      } else {
        $imgContainer.addClass('zooming').zoom({ magnify: 1 });
      }
    });

    // Maps
    // ==============================
    var customMapStyle = $('#customMapStyle');
    var mapStyle = defaultMapStyle;

    if ( customMapStyle.length ) {
      try {
        mapStyle = JSON.parse(customMapStyle.text());
      } catch (err) { // invalid json
        mapStyle = defaultMapStyle;
      }
    }

    //black circle that is the background for the icon.
    var icon = {
      path: 'M 12.5, 25 a 12.5,12.5 0 1,1 25,0 a 12.5,12.5 0 1,1 -25,0',
      fillColor: '#000',
      fillOpacity: 1,
      anchor: new google.maps.Point(25, 25), //position of the icon, careful! this is affected by scale
      labelOrigin: new google.maps.Point(25, 25), //position of the label, careful! this is affected by scale
    }

    var myOptions = {
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      maxZoom: 17,
      styles: mapStyle,
    };

    // Showhome/Contact Map
    // ==============================
    var contactMapEl = document.getElementById('contactMap');
    var contactMapMarkerEl = contactMapEl ? contactMapEl.querySelector('.marker') : undefined;

    if ( contactMapMarkerEl ) {
      if ( contactMapMarkerEl.dataset.lat && contactMapMarkerEl.dataset.lng ) {
        var contactMapPos = new google.maps.LatLng(contactMapMarkerEl.dataset.lat, contactMapMarkerEl.dataset.lng);

        var contactMap = new google.maps.Map(contactMapEl, {
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          mapTypeControl: false,
          zoom: 17,
          styles: mapStyle,
          center: contactMapPos,
        });

        const contactMapIcon = {
          url: contactMapMarkerEl.dataset.ico,
          size: new google.maps.Size(50, 50),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(0, 50),
        };

        new google.maps.Marker({
          position: contactMapPos,
          map: contactMap,
          icon: contactMapIcon.url ? contactMapIcon : icon,
        });
      }
    }

    // Neighbourhood Map
    // ==============================
    var mapEl = document.getElementById('sectionMap');

    function allMarkers(markers) {
      if (markers) {
        for (i = 0; i < markers.length; i++) {
          if ( markers[i]['lat'] && markers[i]['lng'] ) {

            // console.log(markers[i]);
            var pos = new google.maps.LatLng(markers[i]['lat'], markers[i]['lng']);
            bounds.extend(pos);
            marker = new google.maps.Marker({
              position: pos,
              map: map,
              cat:  markers[i]['cat'],
              icon,
              label: {
                fontFamily: '"Font Awesome 5 Pro"',
                text: markers[i]['ico'],
                color: '#fff',
              },
            });

            //Set marker id on links
            var linka = $('.loc_link[data-id="' + markers[i]['id'] +'"]');
            $(linka).attr('data-loc',i);

            makeInfoWindowEvent(map, infowindow, markers[i]['title'], marker);
            markersType.push(marker);
          }
        }
      }
    }

    function makeInfoWindowEvent(map, infowindow, contentString, marker) {
      google.maps.event.addListener(marker, 'mouseover', function() {
        infowindow.setContent(contentString);
        infowindow.open(map, marker);
      });

      google.maps.event.addListener(marker, 'click', function() {
        infowindow.setContent(contentString);
        infowindow.close();
        infowindow.open(map, marker);
       });

      google.maps.event.addListener(marker, 'mouseout', function() {
        infowindow.close();
      });
    }

    function toggleMarkers(category, visible) {
      $(markersType).each(function (id, marker) {
        if(category == marker.cat) {
          marker.setVisible(visible);
        } else if(marker.cat != 'showhome') {
          marker.setVisible(false);
        }
      });
    }

    // If Map exists, initialize map
    if ( mapEl ) {
      var markers = [];

      $('.markers .marker').each(function () {
        markers.push({
          lat: $(this).data('lat'),
          lng: $(this).data('lng'),
          title: $(this).data('title'),
          cat: $(this).data('cat'),
          ico: $(this).data('ico'),
          id: $(this).data('id'),
        });
      });

      var map = new google.maps.Map(mapEl, myOptions);
      var infowindow = new google.maps.InfoWindow();
      var marker, i;
      var bounds = new google.maps.LatLngBounds();

      var markersType = [];
      // var markersGroup = [];

      allMarkers(markers);

      map.fitBounds(bounds);
      map.panToBounds(bounds);

      $('.loc_link').on('click, mouseover', function(){
        var loc = $(this).data('loc');
        google.maps.event.trigger(markersType[loc], 'click');
      });

      //Add showhome marker!
      const image = {
        url: $('.showhome').data('ico'),
        // This marker is 50 pixels wide by 50 pixels high.
        size: new google.maps.Size(50, 50),
        // The origin for this image is (0, 0).
        origin: new google.maps.Point(0, 0),
        // The anchor for this image is the base of the flagpole at (0, 50).
        anchor: new google.maps.Point(0, 50),
      };

      var $showhome = $('.showhome');

      if ( $showhome.length > 0 && $showhome.data('lat') && $showhome.data('lng')) {
        var pos = new google.maps.LatLng($showhome.data('lat'), $showhome.data('lng'));
            bounds.extend(pos);
            marker = new google.maps.Marker({
              position: pos,
              map: map,
              cat:  'showhome',
              icon: image.url ? image : icon,
              title: 'Showhome',
            });
          makeInfoWindowEvent(map, infowindow, $('.showhome').data('title'), marker);
          markersType.push(marker);
      }

      // Set up first
      $('.filter-area').hide(300);
      $('.map-filters button.active').addClass();
      $('.filter-area.' + $('.map-filters button.active').data('val')).show(300);

      $('.map-filters button:not(\'.showAll\')').on('click', function () {
        infowindow.close();
        toggleMarkers($(this).data('val'), $(this).is(':visible'));
        $('.map-filters button').removeClass('active');
        $(this).addClass('active');
        $('.filter-area').hide(300);
        $('.filter-area.' + $(this).data('val')).show(300);
      });

      // $('.map-filters .showAll').on('click', function () {
      //   allMarkers();

      //   $('.map-filters button').removeClass('active');
      //   $(this).addClass('active');

      //   $('.filter-area').show(300);
      // });
    }
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-community.js